import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Box } from '@mui/material'
import { Videos, ChannelCard, VideoCard } from './'
import { fetchFromAPI } from '../utils/fetchFromAPI'

const ChannelDetail = () => {
  const [channelDetail, setChannelDetail] = useState(null)
  const [videos, setVideos] = useState([])
  const { id } = useParams()

  useEffect(() => {
    fetchFromAPI(`channels?part=snippet&id=${id}`)
    .then((data) => setChannelDetail(data.items[0]))
    fetchFromAPI(`search?channelId=${id}&part=snippet&order=date`)
    .then((data) => setVideos(data?.items))
  }, [id])

  return (
    <Box minHeight='95vh'>
      <Box>
        <div style={{ 
          background: 'linear-gradient(141deg, rgba(110,58,199,1) 20%, rgba(0,117,121,1) 60%', 
          height: '300px', 
          zIndex: 10 
        }}
        />
        <ChannelCard channelDetail={channelDetail} marginTop='-121px'/>
      </Box>
      <Box display='flex' p='2'>
        {/* <Box sx={{ mr: { sm: '100px' }}} /> */}
        <Videos videos={videos} />
      </Box>
    </Box>
  )
}

export default ChannelDetail